import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../styles/GlobalStyle.css'
import CustomFooter from '../login/CustomFooter'
import ColType from '../Types'
import { db } from '../firebase/Firebase'
import { flattenDoc, FOLDER_CURRENT, getQueryStringParam } from '../Util'
import { Layout, Row, Col, Select, Icon, Tabs } from 'antd'
import TeacherStudentReport from '../teacher/reports/TeacherStudentReport'
import PersonAvatar from '../customcomponents/PersonAvatar'
import SubjectNoteDisplay from '../teacher/progressmonitoring/SubjectNoteDisplay'
import NoteDisplay from '../teacher/progressmonitoring/NotesDisplay'
import StudentSummary from '../admin/StudentSummary'
const { Content } = Layout
const TabPane = Tabs.TabPane

class InstructionalFacilitatorStudentView extends Component {
    state = {
        schoolId: '',
        teacherId: '',
        teacher: null,
        studentId: '',
        student: null,
        students: null,
        studentDict: {},
        IEPGoals: [],
        IEPDict: {},
    }

    // Do fetch here
    componentDidMount() {
        window.scrollTo(0, 0)
        this.getData()
    }

    componentWillReceiveProps(props, newProps) {
        this.getData()
    }

    getData() {
        let prevSchoolId = this.state.schoolId
        let prevTeacherId = this.state.teacherId
        let prevStudentId = this.state.studentId

        let schoolId = getQueryStringParam('s')
        let teacherId = getQueryStringParam('t')
        let studentId = getQueryStringParam('st')

        if (teacherId && studentId && this.props.instructionalFacilitatorBaseProps.instructionalFacilitator) {
            // already have this data
            if (schoolId === prevSchoolId && teacherId === prevTeacherId && studentId === prevStudentId) {
                return
            }

            this.setState({
                schoolId: schoolId,
                teacherId: teacherId,
                studentId: studentId,
            })

            db.collection(ColType.teacher)
                .doc(teacherId)
                .get()
                .then((doc) => {
                    var teacher = flattenDoc(doc)
                    this.setState({
                        teacher: teacher,
                    })

                    // get students once
                    if (!this.state.students || prevTeacherId !== teacherId) {
                        let students = [];
                        let studentDict = {};
                        let promises = [];
                        let schoolIds = [];
                        if (teacher.hasOwnProperty('schoolId') && teacher.schoolId) {
                            schoolIds = [teacher.schoolId];
                        }
                        if (teacher.hasOwnProperty('schoolIds') && teacher.schoolIds &&
                            teacher.schoolIds.len > 0) {
                            schoolIds = teacher.schoolIds;
                        }
                        schoolIds.forEach((schoolId) => {
                            promises.push(new Promise((resolve, reject) => {
                                db.collection(ColType.student)
                                    .where('teacherIds', 'array-contains', teacherId)
                                    .where('schoolId', '==', schoolId)
                                    .where('districtId', '==', teacher.districtId)
                                    //.where('folder', '==', FOLDER_CURRENT)
                                    .get()
                                    .then((querySnapshot) => {
                                        querySnapshot.forEach((doc) => {
                                            var student = flattenDoc(doc)
                                            students.push(student)
                                            studentDict[student.id] = student
                                        })

                                        resolve();
                                    })
                                    .catch((error) => {
                                        resolve();
                                    })
                            }));
                        })

                        Promise.all(promises)
                            .then(() => {
                                this.setState({
                                    students: students,
                                    studentDict: studentDict,
                                })
                            })
                            .catch((error) => {
                                console.error("Error fetching students: ", error);
                            });
                    }
                })

            db.collection(ColType.student)
                .doc(studentId)
                .get()
                .then((doc) => {
                    var student = flattenDoc(doc)
                    this.setState({
                        student: student,
                    })
                })

            db.collection(ColType.iep)
                .where('districtId', '==', this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.districtId)
                //.where('schoolId', '==', schoolId)
                //.where('teacherId', '==', teacherId)
                .where('studentId', '==', studentId)
                .where('folder', '==', FOLDER_CURRENT)
                .get()
                .then((querySnapshot) => {
                    var IEPGoals = []
                    var IEPDict = {}

                    querySnapshot.forEach((doc) => {
                        var iep = flattenDoc(doc)
                        IEPGoals.push(iep)
                        IEPDict[iep.id] = iep
                    })

                    this.setState({
                        IEPGoals: IEPGoals,
                        IEPDict: IEPDict,
                    })
                })
        }
    }


    render() {
        const schoolName = this.props.instructionalFacilitatorBaseProps.schoolsDict &&
            this.props.instructionalFacilitatorBaseProps.schoolsDict.hasOwnProperty(this.state.schoolId) ?
            this.props.instructionalFacilitatorBaseProps.schoolsDict[this.state.schoolId].schoolName : ''
        const studentFullName = this.state.studentDict &&
            this.state.studentDict.hasOwnProperty(this.state.studentId) ?
            (this.state.studentDict[this.state.studentId].firstName + ' ' +
                this.state.studentDict[this.state.studentId].lastName) : ''
        return (
            <div>
                <div>
                    <Layout className="content relative layout-header-mt">
                        <Layout >
                            <Content>
                                <div>
                                    {this.state.schoolId &&
                                        this.state.student &&
                                        this.state.teacher &&
                                        this.state.teacherId &&
                                        this.state.studentId &&
                                        this.state.studentDict &&
                                        this.state.studentDict.hasOwnProperty(this.state.studentId) &&
                                        this.props.instructionalFacilitatorBaseProps.instructionalFacilitator &&
                                        this.props.instructionalFacilitatorBaseProps.district &&
                                        this.props.instructionalFacilitatorBaseProps.schoolsDict &&
                                        this.props.instructionalFacilitatorBaseProps.schoolsDict.hasOwnProperty(this.state.schoolId)
                                        ?
                                        <div className="sub-menu-width-vlg m-lr-auto mt-3">
                                            <div className='flex'>
                                                <div style={{ width: '1024px', maxWidth: '1024px' }} className='mr-2 relative'>
                                                    {/* Breadcrumb: District > School > Teacher > Student */}
                                                    <div className="w-100 flex flex-v-center mb-2" style={{ fontSize: 16 }}>
                                                        <Link to={'/instructional-facilitator/instructional-facilitator-home/' + this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id}
                                                            style={{ fontWeight: 700, color: '#2d6a9f' }}>
                                                            {this.props.instructionalFacilitatorBaseProps.district.district}
                                                        </Link>
                                                        <Icon type="right" className="ml-1 mr-1" style={{ fontSize: 13, color: '#94a3b8' }} />
                                                        <Link to={'/instructional-facilitator/school/' + this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id + '?s=' + this.state.schoolId}
                                                            style={{ fontWeight: 700, color: '#2d6a9f' }}>
                                                            {schoolName}
                                                        </Link>
                                                        <Icon type="right" className="ml-1 mr-1" style={{ fontSize: 13, color: '#94a3b8' }} />
                                                        <Link to={'/instructional-facilitator/teacher/' + this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id + '?s=' + this.state.schoolId + '&t=' + this.state.teacher.id}
                                                            style={{ fontWeight: 700, color: '#2d6a9f' }}>
                                                            {this.state.teacher.firstName + ' ' + this.state.teacher.lastName}
                                                        </Link>
                                                        <Icon type="right" className="ml-1 mr-1" style={{ fontSize: 13, color: '#94a3b8' }} />
                                                        <span style={{ fontWeight: 700, color: '#1e293b' }}>
                                                            {studentFullName}
                                                        </span>
                                                    </div>
                                                    {/* Gradient hero banner with the student's name */}
                                                    <div className='br-20 overflow-hidden mb-3 mt-2'>
                                                        <div className='br-20 p-3'
                                                            style={{ minHeight: '220px', background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)' }}>
                                                            <div className='h-100'>
                                                                <div className='flex flex-v-center font-40 font-fff w-100 h-100 p-4'>
                                                                    <div className='w-100'>
                                                                        <div className='font-40 font-bold font-fff'>{studentFullName}</div>
                                                                        <div className='font-20 font-fff mt-1'>
                                                                            {this.state.teacher.firstName + ' ' + this.state.teacher.lastName}
                                                                            {schoolName ? ' \u00b7 ' + schoolName : ''}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Tabs size="large" animated={false} className="mt-1">
                                                            <TabPane tab={"Student Report"} key={"student-report"}>
                                                                <div className='mt-2'>
                                                                    <TeacherStudentReport
                                                                        teacherBaseProps={this.state}
                                                                        showStudentNav={false}
                                                                        showFooter={false}
                                                                        noMarginTop={true}
                                                                        isAdmin={true}
                                                                    />
                                                                </div>
                                                            </TabPane>
                                                            <TabPane tab={"Tier One ELA Notes"} key={"ela-notes"}>
                                                                <SubjectNoteDisplay
                                                                    teacherBaseProps={this.state}
                                                                    student={this.state.student}
                                                                    teacherId={this.state.teacherId}
                                                                    studentId={this.state.studentId}
                                                                    IEPId={'tier1'}
                                                                    subject={'ela'}
                                                                    isAdmin={true}
                                                                />
                                                            </TabPane>
                                                            <TabPane tab={"Tier One Math Notes"} key={"math-notes"}>
                                                                <SubjectNoteDisplay
                                                                    teacherBaseProps={this.state}
                                                                    student={this.state.student}
                                                                    teacherId={this.state.teacherId}
                                                                    studentId={this.state.studentId}
                                                                    IEPId={'tier1'}
                                                                    subject={'math'}
                                                                    isAdmin={true}
                                                                />
                                                            </TabPane>
                                                            <TabPane tab={"Tier One SEL Notes"} key={"general-notes"}>
                                                                <NoteDisplay
                                                                    teacherBaseProps={this.state}
                                                                    student={this.state.student}
                                                                    teacherId={this.state.teacherId}
                                                                    studentId={this.state.studentId}
                                                                    IEPId={'tier1'}
                                                                    isAdmin={true}
                                                                />
                                                            </TabPane>
                                                            {/*
                                                                        <TabPane tab={"Uploads"} key={"upload-tab"}>
                                                                            <TeacherStudentUploadView
                                                                                teacherBaseProps={this.state}
                                                                                student={this.state.student}
                                                                                studentId={this.state.student.id}
                                                                                teacherId={this.state.teacherId}
                                                                                IEPId={'tier1'}
                                                                                isAdmin={true}
                                                                            />
                                                                        </TabPane>
                                                                        */}
                                                        </Tabs>
                                                    </div>
                                                </div>
                                                <div className='ml-2'>
                                                    <h1 style={{ fontSize: 24, fontWeight: 800, color: '#1e293b', marginBottom: 12 }}>Students</h1>
                                                    {this.state.students ?
                                                        <Select
                                                            showSearch
                                                            placeholder="Search for a student"
                                                            className='w-100 mb-2'
                                                            optionFilterProp="children"
                                                            onSelect={(studentId) => {
                                                                if (this.props.instructionalFacilitatorBaseProps.instructionalFacilitator && this.state.schoolId && this.state.teacherId && studentId) {
                                                                    this.props.history.push({
                                                                        pathname: "/instructional-facilitator/student/" + this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id + "?s=" + this.state.schoolId + '&t=' + this.state.teacherId + '&st=' + studentId
                                                                    })
                                                                }
                                                            }}
                                                            onSearch={(value) => {
                                                                console.log('search:', value)
                                                            }}
                                                            size="large"
                                                            filterOption={(input, option) => {
                                                                console.log('input', input)
                                                                if (input.length === 0) {
                                                                    return false
                                                                }
                                                                let person = option.props.children.props.person
                                                                let fullName = person.firstName + ' ' + person.lastName
                                                                return fullName.toLowerCase().includes(input.toLowerCase())
                                                            }}
                                                        >
                                                            {this.state.students &&
                                                                this.state.students.map((student, idx) => {
                                                                    return <Select.Option value={student.id} key={'search-' + student.id}>
                                                                        <PersonAvatar
                                                                            person={student}
                                                                            containerClassName="font-16"
                                                                            avatarClassName="font-16 font-bold mr-2"
                                                                            personClassName="font-black font-16"
                                                                        />
                                                                    </Select.Option>
                                                                })}
                                                        </Select>
                                                        : ''}
                                                    {this.state.students && this.state.students.length === 0 ?
                                                        <div style={{ background: '#fff', border: '1px solid #e8eef5', borderRadius: 16, padding: '18px 20px', fontSize: 16, color: '#475569' }}>
                                                            No students yet.
                                                        </div>
                                                        : ''}
                                                    {this.state.students &&
                                                        this.state.students.map((student, idx) => {
                                                            const isCurrent = student.id === this.state.studentId
                                                            return <Link to={"/instructional-facilitator/student/" + this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id + "?s=" + this.state.schoolId + '&t=' + this.state.teacherId + '&st=' + student.id}
                                                                id={student.id} key={student.id}>
                                                                <div style={{ display: 'flex', alignItems: 'center', background: isCurrent ? '#eff6ff' : '#fff', border: isCurrent ? '2px solid #3b82f6' : '1px solid #e8eef5', borderRadius: 16, padding: '14px 16px', marginBottom: 12, boxShadow: 'rgba(100, 100, 111, 0.12) 0px 4px 14px 0px' }}>
                                                                    <PersonAvatar
                                                                        person={student}
                                                                        size={'large'}
                                                                        containerClassName="font-20"
                                                                        avatarClassName="font-20 font-bold mr-2"
                                                                        personClassName="font-black font-20 ellipsis"
                                                                        personStyle={{ maxWidth: '147px' }}
                                                                    />
                                                                    <StudentSummary student={student} />
                                                                </div>
                                                            </Link>
                                                        })}
                                                </div>
                                            </div>
                                        </div> : ''}
                                </div>
                            </Content>
                        </Layout>
                    </Layout>
                </div>
                <CustomFooter />
            </div>
        )
    }
}

export default InstructionalFacilitatorStudentView